<template>
  <div class="quotationPage">
    <headerCom :headerBlue="headerBlue" ref="headerComDom"></headerCom>

    <div class="main-container">
      <div class="main-content">
        <div class="main-quitation-container">
          <div class="main-quitation-title">获取报价</div>
          <div class="main-quitation-info quitationinfo1">
            填写以下信息，我们将为您免费发送服务产品报价单
          </div>
          <div class="main-quitation-input-content">
            <div class="main-quitation-input">
              <label>您的姓名</label>
              <input ref="name" v-model="name" type="text" placeholder="请输入您的姓名" maxlength="100"/>
            </div>
            <div class="main-quitation-input quitationPhone">
              <label>您的联系电话</label>
              <input ref="phone" v-model="phone" type="text" placeholder="请输入联系电话" maxlength="100"/>
              <div class="main-quitation-code" v-if="codeShow" @click="toCreateCode">获取验证码</div>
              <div class="main-quitation-code main-quitation-code-unable" v-if="!codeShow" >{{count}}秒后重试</div>
            </div>
            <div v-if="isCodeInput" class="main-quitation-input">
              <label>验证码</label>
              <input ref="code" v-model="code" type="text" placeholder="请输入验证码" maxlength="100"/>
            </div>
            <div class="main-quitation-input">
              <label>您的电子邮箱</label>
              <input ref="mail" v-model="mail" type="text" placeholder="请输入电子邮箱" maxlength="200"/>
            </div>
            <div class="main-quitation-input">
              <label>公司名称</label>
              <input ref="companyName" v-model="companyName" type="text" placeholder="请输入公司名称" maxlength="300"/>
            </div>
            <div class="main-quitation-input">
              <label>企业性质</label>
              <div class="main-quitation-radio" v-for="(v, index) in companyNatureRadioData" @click="changeCompanyNature(index)" >
                <img class="main-quitation-radio-icon" :src=" v.isChecked ? companyNatureRadioCheckedIconSrc : companyNatureRadioIconSrc " />
                <div class="main-quitation-radio-txt">{{ v.name }}</div>
                <div class="clearboth"></div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="main-quitation-input companySize">
              <label>公司规模</label>
              <input ref="companySize" v-model="companySize" type="text" placeholder="请输入公司员工人数" maxlength="10"/>
              <div class="unit-person">人</div>
            </div>
            <div class="main-quitation-input officeAddress">
              <label>办公地址</label>
              <div class="main-quitation-address">
                <div class="main-quitation-address-input">
                  <input ref="city" v-model="city" type="text" placeholder="输入城市" maxlength="100"/>
                  <div class="main-quitation-address-txt">市</div>
                  <div class="clearboth"></div>
                </div>
                <div class="main-quitation-address-input">
                  <input ref="area" v-model="area" type="text" placeholder="输入区名" maxlength="100"/>
                  <div class="main-quitation-address-txt">区</div>
                  <div class="clearboth"></div>
                </div>
                <div class="clearboth"></div>
              </div>
            </div>
            <div class="main-quitation-input">
              <label>行业类型</label>
              <input ref="industry" v-model="industry" type="text" placeholder="请输入行业类型" maxlength="100"/>
            </div>
            <div class="main-quitation-input">
              <label>有无劳动纠纷或劳动仲裁问题（可多选）</label>
              <div id="laborProblemSelect">
                <div ref="laborProblem" class="main-quitation-select" @click="toShowLaborProblemOption" >
                  <input ref="laborProblemInput" v-model="laborProblemTxt" type="text" placeholder="请选择（可多选）" readonly="readonly" />
                  <img class="main-quitation-select-icon" src="../assets/form_icon_down_arrow.png" />
                </div>
                <div class="main-quitation-option-content" v-show="showLaborProblemOption" >
                  <div :class="[ 'main-quitation-option', v.isChecked ? 'active' : '', ]"
                    v-for="(v, index) in laborProblemOptionData" @click="changeLaborProblemOption(index)" >
                    {{ v.name }}
                    <img class="main-quitation-option-icon" v-if="v.isChecked" src="../assets/form_icon_selected.png" />
                  </div>
                </div>
              </div>
            </div>
            <div class="main-quitation-input">
              <label>有无人事岗位人员（只能选一项）</label>
              <div id="personnelPersonSelect">
                <div ref="personnelPerson" class="main-quitation-select" @click="toShowPersonnelPersonOption" >
                  <input ref="personnelPersonInput" v-model="personnelPersonTxt" type="text" placeholder="请选择（单选）" readonly="readonly" />
                  <img class="main-quitation-select-icon" src="../assets/form_icon_down_arrow.png" />
                </div>
                <div class="main-quitation-option-content" v-show="showPersonnelPersonOption" >
                  <div :class="[ 'main-quitation-option', v.isChecked ? 'active' : '', ]"
                    v-for="(v, index) in personnelPersonOptionData" @click="changePersonnelPerson(index)" >
                    {{ v.name }}
                    <img class="main-quitation-option-icon" v-if="v.isChecked" src="../assets/form_icon_selected.png" />
                  </div>
                </div>
              </div>
            </div>
            <div class="main-quitation-input">
              <label>您选择本产品是想解决什么问题</label>
              <textarea ref="demand" v-model="demand" rows="4" cols="20" placeholder="请输入您的问题" maxlength="1000"></textarea>
            </div>
          </div>
          <div class="main-quitation-info quitationinfo2">
            提交后，您的邮箱自动收到我们公司介绍和服务产品报价单。
          </div>
          <div class="main-quitation-btn" @click="toConsult($event)">提交</div>
        </div>
      </div>
    </div>

    <foot></foot>

    <popup
      v-if="showPromptSuccess"
      :showPromptSuccess="showPromptSuccess" :promptTxt="promptTxt"
      @closePop="closePop"></popup>

  </div>
</template>

<script>
import headerCom from "@/components/Header.vue";
import foot from "@/components/Footer.vue";
import popup from '@/components/popup.vue';
import axios from "axios";

export default {
  data() {
    return {
      headerBlue: true, //表头变蓝
      showPromptSuccess: false,
      promptTxt: '您的获取报价请求已成功发送，<br>您的邮箱将接收我们公司介绍和服务产品报价单！',
      companyNatureRadioData: [
        { id: 4, isChecked: true, name: "民营" },
        { id: 1, isChecked: false, name: "国企" },
        { id: 8, isChecked: false, name: "央企" },
        { id: 2, isChecked: false, name: "事业" },
        { id: 3, isChecked: false, name: "外企" },
      ],
      companyNatureRadioIconSrc: require("../assets/radio_unchecked.png"),
      companyNatureRadioCheckedIconSrc: require("../assets/radio_checked.png"),
      laborProblemOptionData: [
        { id: 1, isChecked: false, name: "当前有纠纷或仲裁" },
        { id: 2, isChecked: false, name: "历史有纠纷或仲裁" },
        { id: 3, isChecked: false, name: "两者都无" },
      ],
      personnelPersonOptionData: [
        { id: 1, isChecked: false, name: "无人事专岗，由财务兼任" },
        { id: 2, isChecked: false, name: "无人事专岗，由行政办公室兼任" },
        {
          id: 3,
          isChecked: false,
          name: "无人事专岗，由管理岗或其他岗人员兼任",
        },
        { id: 4, isChecked: false, name: "有人事专岗人员" },
      ],
      //获取报价-s
      name: "", //姓名
      phone: "", //联系电话
      mail: "", //电子邮箱
      companyName: "", //公司名称
      companyNature: 1, //企业性质
      companySize: "", //公司规模
      city: "", //办公地址 城市
      area: "", //办公地址 区名
      industry: "", //行业类型
      laborProblem: "", //有无劳动纠纷或劳动仲裁问题（可多选）
      personnelPerson: "", //有无人事岗位人员（只能选一项）
      laborProblemTxt: "", //有无劳动纠纷或劳动仲裁问题（可多选）
      personnelPersonTxt: "", //有无人事岗位人员（只能选一项）
      demand: "", //您选择本产品是想解决什么问题
      //获取报价-e
      showLaborProblemOption: false, //有无劳动纠纷或劳动仲裁问题 下拉选项
      showPersonnelPersonOption: false, //有无人事岗位人员 下拉选项

      code: "",
      count: '',
      timer: null,
      codeShow: true,
      isCodeInput: false,

    };
  },
  components: {
    headerCom,
    foot,
    popup
  },
  created() {
    document.addEventListener("click", (e) => {
      let laborProblemSelectDom = document.getElementById("laborProblemSelect");
      let personnelPersonSelectDom = document.getElementById("personnelPersonSelect");
      if (laborProblemSelectDom.contains(e.target)) {
      } else {
        this.showLaborProblemOption = false;
      }
      if (personnelPersonSelectDom.contains(e.target)) {
      } else {
        this.showPersonnelPersonOption = false;
      }
    });
     document.title = '获取报价_薪领航管理咨询有限公司';
  },
  mounted() {
    var Finger = sessionStorage.getItem("Finger")
    if(Finger==null || Finger==""){
      let excludes = {};
      let options = {
        excludes: excludes
      }
      //console.log(options)
      Fingerprint2.get(options, function(components) {
        // 参数
        const values = components.map(function(component) {
          return component.value
        });
        // 指纹
        const murmur = Fingerprint2.x64hash128(values.join(''), 31);
        // view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
        sessionStorage.setItem("Finger", murmur); //存入标识值
        //console.log(murmur);
      });
    }

    document.addEventListener("click", (e) => {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
    });
  },
  methods: {
    //显示 有无人事岗位人员 下拉选
    toShowPersonnelPersonOption() {
      this.showPersonnelPersonOption = true;
    },
    //显示 有无劳动纠纷或劳动仲裁问题 下拉选
    toShowLaborProblemOption() {
      this.showLaborProblemOption = true;
    },
    //改变公司性质 改变点击图标，存值
    changeCompanyNature(index) {
      for (let i = 0; i < this.companyNatureRadioData.length; i++) {
        if (index == i) {
          this.companyNatureRadioData[i].isChecked = true;
          this.companyNature = this.companyNatureRadioData[i].id;
        } else {
          this.companyNatureRadioData[i].isChecked = false;
        }
      }
    },
    //改变有无劳动纠纷或劳动仲裁问题， 改变点击图标，存值
    changeLaborProblemOption(index) {
      var laborProblem = "";
      var laborProblemTxt = "";
      for (let i = 0; i < this.laborProblemOptionData.length; i++) {
        if (index == i) {
          this.laborProblemOptionData[i].isChecked = !this.laborProblemOptionData[i].isChecked;
          if(this.laborProblemOptionData[i].isChecked){
            laborProblem += this.laborProblemOptionData[i].id + ",";
            laborProblemTxt += this.laborProblemOptionData[i].name + "；";
          }
        } else if (this.laborProblemOptionData[i].isChecked) {
          laborProblem += this.laborProblemOptionData[i].id + ",";
          laborProblemTxt += this.laborProblemOptionData[i].name + "；";
        }
      }
      if(laborProblem.length>1){
        laborProblem = laborProblem.substring(0, laborProblem.length - 1);
      }
      if(laborProblemTxt.length>1){
        laborProblemTxt = laborProblemTxt.substring(0, laborProblemTxt.length - 1);
      }
      this.laborProblem = laborProblem;
      this.laborProblemTxt = laborProblemTxt;
    },
    //改变有无人事岗位人员， 改变点击图标，存值
    changePersonnelPerson(index) {
      for (let i = 0; i < this.personnelPersonOptionData.length; i++) {
        if (index == i) {
          this.personnelPersonOptionData[i].isChecked = true;
          this.personnelPerson = this.personnelPersonOptionData[i].id;
          this.personnelPersonTxt = this.personnelPersonOptionData[i].name;
        } else {
          this.personnelPersonOptionData[i].isChecked = false;
        }
      }
    },

    //关闭弹窗
    closePop(){
      this.showPromptSuccess = false;
      document.body.removeAttribute('style');
    },
    //打开 成功提示 弹窗
    toShowPromptSuccess(){
      this.showPromptSuccess = true;
      document.querySelector('body').setAttribute('style', 'width: 100%;height: 100%;overflow: hidden;');
    },
    //提交 获取报价
    toConsult(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,3,0,x,y);
      if(this.name==""){
          alert("请填写您的姓名")
          this.$refs.name.focus()
          return false
      }
      var phonereg = /^[1][3,4,5,7,8][0-9]{9}$/
      if(this.phone==""){
          alert("请填写您的联系电话")
          this.$refs.phone.focus()
          return false
      }else if(!phonereg.test(this.phone)){
          alert("您的联系电话格式有误，请重新填写")
          this.$refs.phone.focus()
          return false
      }
      if(this.code==""){
          alert("请填写验证码")
          this.$refs.code.focus()
          return false
      }else if(this.code!=document.getElementById("randomCode").innerText){
          alert("验证码不正确，请重新输入")
          this.code=""
          this.$refs.code.focus()
          return false
      }

      if(this.mail==""){
          alert("请填写您的电子邮箱")
          this.$refs.mail.focus()
          return false
      }
      if(this.companyName==""){
          alert("请填写公司名称")
          this.$refs.companyName.focus()
          return false
      }

      const isNum = /^[0-9]*$/
      if(this.companySize==""){

      }else if (!isNum.test(this.companySize)) {
        alert("公司规模请填写数字")
        return false
      }
      
    
      /*
      if(this.companySize==""){
          alert("请填写公司规模")
          this.$refs.companySize.focus()
          return false
      }
      if(this.city==""){
          alert("请填写办公地址")
          this.$refs.city.focus()
          return false
      }
      if(this.area==""){
          alert("请填写办公地址")
          this.$refs.area.focus()
          return false
      }
      if(this.industry==""){
          alert("请填写行业类型")
          this.$refs.industry.focus()
          return false
      }
      if(this.laborProblem==""){
          alert("请选择有无劳动纠纷或劳动仲裁问题")
          this.$refs.laborProblemInput.focus()
          return false
      }
      if(this.personnelPerson==""){
          alert("请选择有无人事岗位人员")
          this.$refs.personnelPersonInput.focus()
          return false
      }
      if(this.demand==""){
          alert("请填写您的问题")
          this.$refs.demand.focus()
          return false
      }
      */
     
      let params = {};
      params.type = 2;
      params.name = this.name;//姓名
      params.phone = this.phone;//联系电话
      params.mail = this.mail;//电子邮箱
      params.companyName = this.companyName;//公司名称
      params.companyNature = this.companyNature;//企业性质
      params.companySize = this.companySize;//公司规模
      params.city = this.city;//办公地址 城市
      params.area = this.area;//办公地址 区名
      params.industry = this.industry;//行业类型
      params.laborProblem = this.laborProblem;//有无劳动纠纷或劳动仲裁问题
      params.personnelPerson = this.personnelPerson;//有无人事岗位人员
      params.demand = this.demand;//需求
      params.browserId = sessionStorage.getItem("Finger");//浏览器标识
      if(!params.companyNature){
        params.companyNature = 0;
      }
      if(!params.companySize){
        params.companySize = 0;
      }
      if(!params.personnelPerson){
        params.personnelPerson = 0;
      }
      axios
        .post("pilotage/webConsult", params)
        .then((res) => {
            if(res.data.success!=null && res.data.success==1){
                this.closePop();
                this.toShowPromptSuccess();
            }else if(res.data.success!=null && res.data.success==3){
                alert("您已提交，请勿重复提交，请耐心等待回复！")
            }else{
              alert("提交失败，请您重新提交！")
            }
        })
        .catch((res) => {
          alert("提交失败，请您重新提交！")
        });
    },

    //创建验证码
    toCreateCode(){
      var phonereg = /^[1][3,4,5,7,8][0-9]{9}$/
      if(this.phone==""){
        alert("请填写您的联系电话")
        this.$refs.phone.focus()
        return false
      }else if (phonereg.test(this.phone)) {
        this.isCodeInput = true;
        createRandomCode();

        let params = {};
        params.type = 1;
        params.phone = this.phone;//联系电话
        params.code = document.getElementById("randomCode").innerText;//联系电话
        
        axios
          .post("pilotage/sendCode", params)
          .then((res) => {
            if(res!=null && res.data!=null){
              
            }
          })
          .catch((res) => {
          });
        
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.codeShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
               this.count--;
            } else {
               this.codeShow = true;
               clearInterval(this.timer);
               this.timer = null;
            }
         }, 1000)
      
        }

      }else{
        alert("您的联系电话格式有误，请重新填写")
        this.$refs.phone.focus()
        return false
      }
    },

  },
};
</script>

<style>

.main-quitation-container {
  width: calc(100% - 360px);
  margin: auto;
  background: #eef4fe;
  text-align: center;
  padding: 40px 0 50px 0;
}
.main-quitation-title {
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 36px;
  line-height: 47px;
  color: #1055c1;
}
.main-quitation-info {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #999999;
}
.main-quitation-info.quitationinfo1 {
  margin: 16px 0 0 0;
}
.main-quitation-info.quitationinfo2 {
  margin: 50px 0 0 0;
}
.main-quitation-input-content {
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #333333;
  margin: 20px 0 0 0;
}
.main-quitation-input {
  width: 500px;
  margin: auto;
  margin: 20px auto auto auto;
  position: relative;
}
.main-quitation-input label {
  text-align: left;
  display: block;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #333333;
}
.main-quitation-input input {
  padding: 0 8px;
  width: calc(100% - 16px);
  height: 40px;
  margin: 8px 0 0 0;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ffffff;
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.main-quitation-input textarea {
  margin: 8px 0 0 0;
  width: calc(100% - 16px);
  height: 120px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ffffff;
  resize: none;
  padding: 8px 8px;
  font-size: 16px;
  line-height: 24px;
  font-family: Noto Sans SC;
  color: #333333;
}

.main-quitation-input.quitationPhone input{
  width: 353px;
}

.main-quitation-input.quitationPhone .main-quitation-code{
  margin-left: 4px;
  background: #1055c1;
  border-radius: 5px;
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 14px;
  line-height: 42px;
  text-align: center;
  color: #FFFFFF;
  height: 42px;
  cursor: pointer;
  width: 120px;
  display: inline-block;
}

.main-quitation-input.quitationPhone .main-quitation-code-unable{
  background: #c9c9c9;
  cursor: auto;
}

.main-quitation-input .main-quitation-radio {
  float: left;
  margin: 8px 0 0 18px;
  cursor: pointer;
}
.main-quitation-input .main-quitation-radio:first-of-type {
  margin-left: 8px;
}
.main-quitation-input .main-quitation-radio .main-quitation-radio-icon {
  float: left;
  height: 12px;
  width: auto;
  margin: 6px 8px 0 0;
}
.main-quitation-radio-txt {
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  float: left;
}
.main-quitation-input.companySize input {
  padding-right: 30px;
  width: calc(100% - 38px);
}
.unit-person {
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  position: absolute;
  bottom: 9px;
  right: 6px;
}
.main-quitation-input .main-quitation-address {
  background: #ffffff;
  padding: 0 8px;
  width: calc(100% - 80px);
  height: 40px;
  margin: 8px 0 0 0;
  border-radius: 2px;
  border: 1px solid #ffffff;
}
.main-quitation-input
  .main-quitation-address
  .main-quitation-address-input
  input {
  width: 72%;
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  float: left;
  border: 0;
}
.main-quitation-input .main-quitation-address .main-quitation-address-input {
  float: left;
  width: 45%;
}
.main-quitation-input
  .main-quitation-address
  .main-quitation-address-input
  .main-quitation-address-txt {
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
  color: #333333;
  float: left;
}

.main-quitation-input .main-quitation-select {
  position: relative;
}
.main-quitation-input .main-quitation-select .main-quitation-select-icon {
  width: 20px;
  height: auto;
  position: absolute;
  top: 20px;
  right: 8px;
}
.main-quitation-input .main-quitation-option-content {
  background: #ffffff;
  width: calc(100% + 18px);
  border: 0;
}
.main-quitation-input .main-quitation-option-content .main-quitation-option {
  text-align: left;
  height: 40px;
  width: calc(100% - 16px);
  padding: 0 8px;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
  color: #999999;
  position: relative;
  cursor: pointer;
}
.main-quitation-input
  .main-quitation-option-content
  .main-quitation-option:hover {
  background: #f3f7fc;
  color: #1055c1;
}
.main-quitation-input
  .main-quitation-option-content
  .main-quitation-option.active {
  background: #f3f7fc;
  color: #1055c1;
}
.main-quitation-input
  .main-quitation-option-content
  .main-quitation-option
  .main-quitation-option-icon {
  height: 20px;
  width: auto;
  position: absolute;
  top: 12px;
  right: 10px;
}

.main-quitation-input input::-webkit-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.main-quitation-input input:-moz-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
}

.main-quitation-input input:-ms-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
}

.main-quitation-input textarea::-webkit-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.main-quitation-input textarea:-moz-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.main-quitation-input textarea:-ms-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.main-quitation-btn {
  margin: 20px 0 0 0;
  background: #1055c1;
  border-radius: 10px;
  width: 180px;
  height: 56px;
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 56px;
  text-align: center;
  color: #ffffff;
  display: inline-block;
  cursor: pointer;
}
.popup-container {
    width: 740px;
    height: auto;
    margin: auto;
    position: fixed;
    top: 78px;;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
  }

  .popAppointAssessSuccess.popup-container {
    width: 840px;
    top: 80px;
    background: #FFFFFF;
    text-align: center;
    padding: 99px 0 98px 0;
  }
  .popup-close-img-container {
    cursor: pointer;
    position: absolute;
    top: 29px;
    right: 34px;
  }

  .popup-close-img {
    width: 24px;
    height: auto;
  }

  .popAppointAssessSuccess .popup-close-img-container {
    top: 24px;
    right: 24px;
  }

  .popup-hint-icon-container {}

  .popup-hint-icon {
    height: 145px;
    width: auto;
  }

  .popup-hint {
    font-family: Noto Sans SC;
    font-size: 24px;
    line-height: 40px;
    text-align: center;
    color: #1055C1;
    width: 545px;
    display: inline-block;
    margin: 62px 0 0 0;
  }

  .popup-btn {
    background: #1055C1;
    border-radius: 10px;
    font-family: Noto Sans SC;
    font-weight: 500;
    font-size: 16px;
    line-height: 56px;
    text-align: center;
    color: #FFFFFF;
    width: 180px;
    height: 56px;
    display: inline-block;
    margin: 16px 0 0 0;
    cursor: pointer;
  }
  .popAppointAssessSuccess .popup-btn {
    margin: 51px 0 0 0;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/quotation.vue